module.exports = __webpack_public_path__ + "img/consultoria_16-9_960.6c60bf8f.jpg";